import { CatalogGeoLocationComparators } from '../renderers/condition/comparator/constants';
import { CompleteCondition, GeoLocationValue, FieldType } from '../types';

export const convertToIsWithinGeoLocationCondition = (condition: CompleteCondition) => {
  if (
    condition.fieldType === FieldType.GEO_LOCATION &&
    condition.comparatorType === CatalogGeoLocationComparators.IS_WITHIN
  ) {
    const { location, distance, ...remainingConditionFields } = condition as CompleteCondition &
      GeoLocationValue;
    return {
      ...remainingConditionFields,
      value: {
        location,
        distance,
      },
    };
  }
  return condition;
};
